module.exports = __webpack_public_path__ + "img/stock0.86332db6.png";